import React from "react";
import PropTypes from "prop-types";

import "./AddressListing.scss";

export default class AddressListing extends React.Component {
  render() {
    const { pinNumber, name, street, addressRemainder } = this.props;

    return (
      <div
        className="listingContainer"
        onClick={this.props.clickAddress}
        id={`address_${pinNumber}`}
      >
        <div className="pinDiv">
          <div className="numberPin">
            <div className="number">{pinNumber}</div>
          </div>
        </div>
        <div className="nameDiv">
          {name}
          <br />
          {street}
          <br />
          {addressRemainder}
        </div>
      </div>
    );
  }
}

AddressListing.propTypes = {
  clickAddress: PropTypes.func,
  pinNumber: PropTypes.number,
  name: PropTypes.string,
  street: PropTypes.string,
  addressRemainder: PropTypes.string
};
